// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__3lgxB","loadingShrink":"PageLoading_loadingShrink__2aAK0"};